export const NO_CUSTOMER_ID = 'internal';

export class TimesheetEntry {

    id = "";

    /**
     * @type {Task}
     */
    task;

    billable = true;

    /**
     * @type {Date}
     */
    start;

    /**
     * @type {Date}
     */
    end;

    /**
     * Duration in seconds
     * @type {number}
     */
    duration = 0;

    description = "";

    /**
     * @type {string[]|Tag[]}
     */
    tags = [];

    source = ""

    /**
     * Mark if it is not still running (and was already logged).
     * @type {boolean}
     */
    isLogged = true;

    /**
     * @return {boolean}
     */
    isBillable() {
        if (!this.billable || !this.belongsToCustomer()) {
            return false;
        }
        return this.task.customer.id !== NO_CUSTOMER_ID;
    }

    /**
     * @return {boolean}
     */
    belongsToCustomer() {
        return !!(this.task && this.task.customer && this.task.customer.id);
    }
}